import React, { createContext, useContext, useState, useEffect } from 'react';
import { Locale, LocalizedText } from '../types';
import { DICTIONARY, UiDictionary, resolveLocalizedText } from '../data/i18n';

interface I18nContextType {
  locale: Locale;
  setLocale: (locale: Locale) => void;
  t: UiDictionary;
  resolveText: (text: LocalizedText) => string;
}

const I18nContext = createContext<I18nContextType | undefined>(undefined);

export const I18nProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [locale, setLocaleState] = useState<Locale>(() => {
    const saved = localStorage.getItem('project_kapital_locale');
    return saved === 'en' ? 'en' : 'ko'; // Korean default
  });

  const setLocale = (newLocale: Locale) => {
    setLocaleState(newLocale);
    localStorage.setItem('project_kapital_locale', newLocale);
  };

  useEffect(() => {
    document.documentElement.lang = locale;
  }, [locale]);

  const value: I18nContextType = {
    locale,
    setLocale,
    t: DICTIONARY[locale],
    resolveText: (text: LocalizedText) => resolveLocalizedText(text, locale),
  };

  return <I18nContext.Provider value={value}>{children}</I18nContext.Provider>;
};

export const useI18n = (): I18nContextType => {
  const context = useContext(I18nContext);
  if (!context) {
    throw new Error('useI18n must be used within an I18nProvider');
  }
  return context;
};
